import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { useUserContext } from '@module/mdrt-org/shared/components/providers/user-context';
import { OrgSharedDataTag } from '@module/mdrt-org/shared/utils/data/constants/tags';
import { getCustomerProfileAdB2CObjectId } from '@module/mdrt-org/shared/utils/data/get-customer-profile-ad-b2c-object-id';
import { parseJwtToken } from '@shared/misc/utils/parse-jwt-token';
export const useAdB2cObjectId = () => {
  const $ = _c(11);
  const {
    accessToken,
    personId,
    personIdBeforeImpersonation
  } = useUserContext();
  let t0;
  if ($[0] !== accessToken) {
    t0 = accessToken ? parseJwtToken(accessToken) : undefined;
    $[0] = accessToken;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const parsedToken = t0;
  const t1 = Boolean(accessToken && personId && personIdBeforeImpersonation);
  let t2;
  if ($[2] !== accessToken || $[3] !== personId) {
    t2 = () => getCustomerProfileAdB2CObjectId({
      accessToken,
      personId
    });
    $[2] = accessToken;
    $[3] = personId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== personId) {
    t3 = [OrgSharedDataTag.GET_CUSTOMER_PROFILE_ADB2C_OBJECT_ID, personId];
    $[5] = personId;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = {
      enabled: t1,
      queryFn: t2,
      queryKey: t3,
      retryDelay: _temp,
      staleTime: Infinity
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    data: customerProfileAdB2CObjectIdResponse
  } = useQuery(t4);
  return personIdBeforeImpersonation && personId ? customerProfileAdB2CObjectIdResponse?.objectId : parsedToken ? parsedToken.sub : undefined;
};
function _temp(attemptIndex) {
  return 8000 + attemptIndex * 4000;
}